var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.tagList, function (item, index) {
    return _c("div", {
      key: index
    }, [index != 0 ? _c("span", {
      staticStyle: {
        "margin-right": "8px"
      }
    }, [_vm._v("、")]) : _vm._e(), _vm._l(item, function (item2, index2) {
      return _c("span", {
        key: index2
      }, [index2 != 0 ? _c("span", {
        staticStyle: {
          "margin-right": "8px"
        }
      }, [_vm._v(_vm._s(_vm.$t("或")))]) : _vm._e(), item2.choice ? _c("a-tag", {
        key: item2.fieldKey + item2.fieldValue,
        attrs: {
          color: "blue",
          closable: ""
        },
        on: {
          close: function ($event) {
            return _vm.tagClose(index, index2, item2);
          }
        }
      }, [_vm._v(" " + _vm._s(item2.fieldKey) + ":" + _vm._s(item2.fieldFrontValue || item2.fieldValue) + " ")]) : _vm._e()], 1);
    })], 2);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };